<template>
	<Flyout
		:title="'Edit 3P Vendor Integration Details'"
		:parentTag="'form'"
		:display="display"
		:novalidate="'novalidate'"
		@show="closeIntegrationDetailsFlyout"
	>
		<template #flyout-content
			><div class="edit-vendor-int-details">
				<div class="edit-vendor-int-details__fields">
					<div class="edit-vendor-int-details__fields-group">
						<div class="edit-vendor-int-details__name-notification">
							<BlockNotifications
								message="The Integration Name submitted has the same or similar name to an existing Integration."
								:blockState="'warning'"
								:blockVariant="'small'"
							/>
						</div>

						<Input
							className="field__input"
							type="text"
							label="Integration Name"
							name="Name"
							inputType="text"
							:maxLength="200"
							:required="true"
							v-model="integrationData.name"
						/>
						<Input
							className="field__input"
							type="text"
							label="Alias Name (optional)"
							name="Alias"
							inputType="text"
							:maxLength="100"
							v-model="integrationData.alias"
						/>
						<Dropdown
							label="DMS-IS"
							:autosuggestion="false"
							:displayHelp="false"
							:options="integrationSolutionOptions"
							v-model="integrationData.dmsis"
							:defaultValue="'Select one'"
						/>
						<DropdownMultiselect
							label="APIs"
							:options="apiMultipleSelectOpts"
							:defaultValue="'Select multiple'"
							v-model="apiSelectedValues"
						/>
						<Input
							className="field__input"
							label="Username"
							name="Alias"
							inputType="password"
							:maxLength="100"
							v-model="integrationData.username"
						/>
						<Input
							className="field__input"
							type="text"
							label="Password"
							name="Alias"
							inputType="password"
							:maxLength="100"
							v-model="integrationData.userPassword"
						/>
					</div>

					<div class="edit-vendor-int-details__employee">
						<span class="edit-vendor-int-details__fields-title">
							Global Employee
						</span>
						<IconInfo
							position="top"
							:text="textIconInfo"
							class="edit-vendor-int-details__fields-title-icon"
						></IconInfo>
						<div class="edit-vendor-int-details__fields-hlp-txt">
							Choose an existing global employee or create a new
							one.
						</div>

						<div class="edit-vendor-int-details__employee-existing">
							<Dropdown
								:autosuggestion="true"
								:displayHelp="false"
								:options="employeeOptions"
								v-model="integrationData.employeeId"
								:defaultValue="'Select one'"
							/>
							<span
								class="edit-vendor-int-details__employee-existing-txt"
								>or</span
							>

							<Button
								v-show="!integrationData.canAddGlobalEmployee"
								className="btn--has-icon"
								iconClassName="icon-more"
								labelText="Create New"
								:iconBeforeLabel="true"
								:btnClick="addEmployee"
							/>
						</div>

						<SectionContainer
							v-if="integrationData.canAddGlobalEmployee"
							class="edit-vendor-int-details__employee-add"
						>
							<template #left>
								<span>ADD NEW GLOBAL EMPLOYEE</span>
							</template>
							<template #content>
								<div
									class="edit-vendor-int-details__fields-group"
								>
									<div
										class="edit-vendor-int-details__name-notification"
									>
										<BlockNotifications
											message="The Integration Name submitted has the same or similar name to an existing Integration."
											:blockState="'warning'"
											:blockVariant="'small'"
										/>
									</div>
									<Input
										className="field__input"
										label="3P Partner"
										name="employeeFirstName"
										v-model="
											integrationData.employeeFirstName
										"
										:required="true"
									/>
									<Input
										className="field__input"
										label="Integration Name"
										name="employeeLastName"
										v-model="
											integrationData.employeeLastName
										"
										:required="true"
									/>
									<Input
										label="Email"
										inputType="Email"
										name="email"
										placeholder="example@mail.com"
										v-model="integrationData.employeeEmail"
										:required="true"
										@hasError="handleEmailError"
									/>
									<span
										class="edit-vendor-int-details__fields-group-action"
									>
										<Button
											labelText="Cancel"
											:btnClick="cleanGlobalEmployee"
											:iconBeforeLabel="true"
										/>
									</span>
								</div>
							</template>
						</SectionContainer>
					</div>

					<div class="edit-vendor-int-details__details">
						<div class="edit-vendor-int-details__fields-title">
							Integration Details
						</div>
						<div class="edit-vendor-int-details__fields-group">
							<Dropdown
								label="Category of Service"
								:autosuggestion="true"
								:displayHelp="false"
								:options="essentialOptions"
								:defaultValue="'Select one'"
								v-model="integrationData.essentialCategory"
							/>
							<DropdownMultiselect
								label="Module Category"
								:options="moduleCategoriesOptions"
								:defaultValue="'Select multiple'"
								v-model="moduleCategoryData"
								variant="tags"
							/>
						</div>
					</div>

					<div class="edit-vendor-int-details__hardware">
						<span class="edit-vendor-int-details__fields-title"
							>Hardware</span
						>
						<div class="edit-vendor-int-details__fields-hlp-txt">
							Is hardware required?
						</div>
						<RadioButtonGroup
							:items="yesNoOptions"
							v-model="isHardwareSpecRequired"
							class="edit-vendor-int-details__fields-radio"
						/>
						<Textarea
							label="Hardware Specifications"
							:cols="50"
							:rows="3"
							:maxLength="200"
							v-model="integrationData.hardwareSpectications"
							:required="isHardwareSpecRequired"
						/>
					</div>

					<!--review max on text area-->

					<div class="edit-vendor-int-details__additional-setups">
						<div class="edit-vendor-int-details__fields-title">
							Additional Setups
						</div>
						<div class="edit-vendor-int-details__fields-hlp-txt">
							Does the integration have additional setup
							components? If yes, please note any additional steps that
							may be required in VUE Default Settings or by logging
							into the 3P Vendor Integration and adjusting
							settings.
						</div>
						<RadioButtonGroup
							:items="yesNoOptions"
							v-model="isSetupSpecRequired"
							class="edit-vendor-int-details__fields-radio"
						/>
						<Textarea
							label="Setup Specifications"
							:cols="50"
							:rows="3"
							:maxLength="200"
							v-model="integrationData.setupSpectications"
							:required="isSetupSpecRequired"
						/>
					</div>

					<div class="edit-vendor-int-details__additional-features">
						<div class="edit-vendor-int-details__fields-title">
							Additional Features
						</div>
						<div class="edit-vendor-int-details__fields-hlp-txt">
							Does our end user need to interact with VUE DMS? If
							yes, please note the feature and steps that are
							needed (for example, end user clicks a button in VUE
							DMS to import data).
						</div>
						<RadioButtonGroup
							:items="yesNoOptions"
							v-model="isFeatureSpecRequired"
							class="edit-vendor-int-details__fields-radio"
						/>
						<Textarea
							label="Feature specifications"
							:cols="50"
							:rows="3"
							:maxLength="200"
							v-model="integrationData.featureSpectications"
							:required="isFeatureSpecRequired"
						/>
					</div>

					<div class="edit-vendor-int-details__note-description">
						<div class="edit-vendor-int-details__fields-title">
							Notes and Description
						</div>
						<Textarea
							label="Internal Notes"
							:cols="50"
							:rows="3"
							:maxLength="500"
							v-model="integrationData.internalNotes"
						/>
						<Textarea
							label="3P Vendor Integration Description"
							:cols="50"
							:rows="3"
							:maxLength="500"
							v-model="integrationData.description"
						/>
					</div>
					<!--TODO import button functionability-->
				</div>
				<Modals
					v-model="showConfirmation"
					:type="'confirmation'"
					:buttons="saveModalButtonsFromFlyout"
					:title="'Would you like to save changes before exiting?'"
					:confirmationContent="'Unsaved changes will be lost.'"
					@confirm="saveAction"
					@cancel="cancelAndSaveAction"
				/>
			</div>
			<Tooltip
				:text="
					'Create a unique integration name. Integration name is too similar to an existing integration.'
				"
				:trackedRefName="'tooltipRef'"
				:display="true"
				:offset="[4, 4]"
				strategy="absolute"
			/>
		</template>

		<template #flyout-footer>
			<ButtonGroup
				:items="[
					{
						btnClick: saveAction,
						className: 'btn--primary',
						labelText: 'Save Changes',
						ref: 'tooltipRef',
						disabled: !hasIntegrationChanges
					},
					{
						btnClick: cancelAndSaveAction,
						className: 'btn btn--link',
						labelText: 'Cancel'
					}
				]"
			/>
		</template>
	</Flyout>
</template>

<script>
import Flyout from '@/components/shells/flyout/flyout';
import Button from '@/components/forms/button/button';
import ButtonGroup from '@/components/forms/button/button-group';
import BlockNotifications from '@/components/notifications/block-notifications/block-notifications';
import Input from '@/components/forms/input/input';
import Modals from '@/components/shells/modal/modals';
import DropdownMultiselect from '@/components/forms/dropdown/dropdown-multiselect.vue';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import Textarea from '@/components/forms/textarea/textarea.vue';
import Tooltip from '@/components/shells/tooltip/tooltip';
import RadioButtonGroup from '@/components/forms/selection-control/radiobutton/radiobutton-group';
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import {
	moduleCategoriesOpts,
	essentialOpts
} from '@/sections/vendors/integrations/integrationsSettings';
import {
	MODULE_NAME,
	INTEGRATION,
	SAVE_INTEGRATION
} from '../integrations-mutation-types';
import { createPatch } from 'rfc6902';
import IconInfo from '@/components/notifications/icon-info/icon-info';
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'VendorIntegrationDetailsFlyout',
	components: {
		Flyout,
		Button,
		ButtonGroup,
		BlockNotifications,
		Input,
		Modals,
		DropdownMultiselect,
		Dropdown,
		Textarea,
		Tooltip,
		RadioButtonGroup,
		IconInfo,
		SectionContainer
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			integrationData: {},
			originalIntegration: {},
			showConfirmation: false,
			saveModalButtonsFromFlyout: [
				{
					className: 'btn--primary',
					labelText: 'Yes, save changes',
					btnClick: this.saveAction
				},
				{
					className: 'btn--link',
					labelText: 'Do not save',
					btnClick: this.cancelAndClose
				}
			],
			integrationSolutionOptions: [
				{
					text: 'Yes',
					value: true
				},
				{
					text: 'No',
					value: false
				}
			],
			apiMultipleSelectOpts: [
				{
					text: 'GetPersonnel',
					value: 1
				},
				{
					text: 'GetCustomerInformation',
					value: 2
				},
				{
					text: 'GetStandardCodes',
					value: 3
				}
			],
			apiSelectedValues: [1, 2],
			employeeOptions: [
				{
					text: 'Employee option 1',
					value: 1
				},
				{
					text: 'Employee option 2',
					value: 2
				},
				{
					text: 'Employee option 3',
					value: 3
				},
				{
					text: 'Employee option 4',
					value: 4
				}
			],
			yesNoOptions: [
				{
					labelText: 'Yes',
					value: true
				},
				{
					labelText: 'No',
					value: false
				}
			],
			isHardwareSpecRequired: false, // TODO: review the default value for this component
			isSetupSpecRequired: false, // TODO: review the default value for this component
			isFeatureSpecRequired: false,
			moduleCategoriesOptions: moduleCategoriesOpts,
			essentialOptions: essentialOpts,
			moduleCategoryData: [],
			originalmoduleCategory: [],
			textIconInfo:
				'The Vendor and Integration Name can be viewed by DMS users if the integration is responsible for creating or editing information in VUE.'
		};
	},
	computed: {
		...mapGetters(MODULE_NAME, [INTEGRATION]),

		hasIntegrationChanges() {
			return (
				!_.isEqual(this[INTEGRATION], this.integrationData) ||
				!_.isEqual(this.moduleCategoryData, this.originalmoduleCategory)
			);
		}
	},
	methods: {
		...mapActions(MODULE_NAME, {
			saveIntegrationAction: SAVE_INTEGRATION
		}),

		async saveAction() {
			let integration = _.cloneDeep(this.integrationData);
			if (
				!_.isEqual(this.moduleCategoryData, this.originalmoduleCategory)
			) {
				integration.moduleCategories = this.moduleCategoryData.toString();
			}
			let patchedObj = createPatch(integration, this.originalIntegration);
			await this.saveIntegrationAction({
				vendorid: this.originalIntegration.integratorId,
				id: this.originalIntegration.id,
				payload: patchedObj
			}).then();
			this.cancelAndClose();
		},
		closeIntegrationDetailsFlyout() {
			this.cancelAndSaveAction();
		},
		cancelAndSaveAction(e) {
			if (e) e.preventDefault();
			if (this.hasIntegrationChanges) {
				this.showConfirmation = true;
			} else {
				this.cancelAndClose();
			}
		},
		cancelAndClose() {
			this.integrationData = {};
			this.showConfirmation = false;
			this.$emit('show', false);
		},
		cleanGlobalEmployee() {
			this.integrationData.employeeFirstName = '';
			this.integrationData.employeeLastName = '';
			this.integrationData.employeeEmail = '';
			this.integrationData.canAddGlobalEmployee = false;
		},
		handleEmailError(obj) {
			this.invalidEmail = obj['email'];
		},
		addEmployee() {
			this.integrationData.employeeId = '';
			this.integrationData.canAddGlobalEmployee = true;
		}
	},
	watch: {
		display: {
			immediate: true,
			deep: true,
			handler(val) {
				if (val) {
					const parseCategories = string => {
						let array = string.split(',');
						return array.map(element => parseInt(element));
					};

					if (_.isEmpty(this[INTEGRATION])) {
						this.$store.dispatch('toastMessages/show', {
							toastId: 'integration.details',
							statusCode: 400,
							message: 'Integration data is empty',
							slot: 'default',
							useIcon: true,
							userDismissable: true
						});

						this.cancelAndClose();
						return;
					}

					this.originalIntegration = _.cloneDeep(this[INTEGRATION]);

					this.integrationData = _.cloneDeep(
						this.originalIntegration
					);
					if (this.integrationData.moduleCategories) {
						this.moduleCategoryData = parseCategories(
							this.integrationData.moduleCategories
						);
						this.originalmoduleCategory = [
							...this.moduleCategoryData
						];
					}
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Edit 3P Vendor Integration Details Flyout
    * Can use SCSS variables = TRUE
    *
 **/
.edit-vendor-int-details {
	&__fields {
		display: flex;
		flex-direction: column;
		gap: $gutter-xxl;
	}

	&__fields-group {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: $gutter-lg;

		&-action {
			margin-top: 19px;
		}
	}

	&__fields-title {
		@include heading('md');
	}

	&__fields-title-icon {
		margin-left: $gutter-sm;
	}

	&__fields-hlp-txt {
		@include sub-heading;
		margin-top: $gutter-md;
		text-align: justify;
	}

	&__fields-radio {
		display: flex;		
		margin: $gutter-lg $gutter-sm;
	}

	&__name-notification {
		grid-column: 1 / 3;
	}

	&__employee-existing {
		display: flex;
		gap: $gutter-lg;
		margin-top: $gutter-lg;
		align-items: center;

		::v-deep.dropdown {
			width: 256px;
		}

		&-txt {
			@include body-text('regular');
			font-style: italic;
		}
	}

	&__employee-add {
		padding-left: $padding-sm;
		margin-top: $gutter-lg;
	}

	&__details .edit-vendor-int-details__fields-group {
		margin-top: $gutter-lg;
	}	

	&__note-description .edit-vendor-int-details__fields-title {
		margin-bottom: $gutter-lg;
	}	
}

::v-deep .flyout {
	@include mq($from: md) {
		max-width: initial;
		width: 620px;
	}
}

::v-deep .flyout__body {
	@include scrollbar;
}

::v-deep .tooltip {
	max-width: 220px;
}
</style>

